module.exports = __webpack_public_path__ + "media/images/info-up-7b0ee74e64cde1bc668a59f8deb2359c.png";